//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import stepTitle from "../StepTitle"
	import datePicker from "../DatePicker"
	import idCardInput from '../IdCardInput'
	import rules from './rules'
	import { api, config } from '@/service'
	import hongKongAreaList from '@/utils/hongKongAreaList'
	import checkBox from '@/components/check-box'
	import radioBox from '@/components/radio-box'
	import imgTools from '@/components/imgTools'
	import Vue from 'vue'
	import umallSearch from "@/components/searchInput";

	const formattingTime = param => {
		let _time = param.split('-').map(e => {
			if(e * 1 < 10) return `0${e}`
			else return e
		})
		return _time.join('-')
	}

	export default {
		props: {
			wayTransactType: {
				type: [String, Number],
				default: '2'
			},
			type: {
				type: [String, Number],
				default: 1
			},
    	disVasTotal: {  // 優惠與VAS展示數總和
        type: Number,
        default: 0,
      },
      shrink:{//是否需要收缩条
        type: Boolean,
        default: false 
      },
		},
		watch: {
			'search'(newW, oldW) {
				console.log(newW)
				console.log(oldW)
			}
		},
		data() {
			let validatorMail = (rule, value, callback) => {
				if(this.type == 2) return callback()
				if(value === '') {
					callback(new Error('請輸入電郵'));
				} else if(!(/^.+@[0-9a-zA-Z]+(\.[A-Za-z0-9]+){1,4}$/.test(value))) {
					callback(new Error('您輸入的電郵有誤'));
				} else callback()
			}
			// 邮箱二次验证
			let validatorMail2 = (rule, value, callback) => {
				if(this.type == 2) return callback()
				if(value === '') {
					callback(new Error('請輸入電郵'));
				} else if(!(/^.+@[0-9a-zA-Z]+(\.[A-Za-z0-9]+){1,4}$/.test(value))) {
					callback(new Error('您輸入的電郵有誤'));
				} else if(value !== this.form.customerInfo_email) {
					callback(new Error('電郵地址不一致,請重新輸入'));
				} else callback()
			}

			// 当类型为专人办理不需要输入这些参数
			let validatorType = (rule, value, callback, text) => {
				if(this.type == 2) return callback()
				if(value === '' || value === null) callback(new Error(text))
				else callback()
			}

			/**
			 * @method validatorAddressInfoVo 校验街道和屋苑至少有一个填了
			 */
			let validatorAddressInfoVo = (rule, value, callback, errorText) => {
				if(!this.form.addressInfoVo_streetName && !this.form.addressInfoVo_estateInput) return callback(new Error(errorText))
				else {
					this.$refs.form.clearValidate('addressInfoVo_streetName')
					this.$refs.form.clearValidate('addressInfoVo_estateInput')
					callback()
				}
			}
			/**
			 * @method validatorContactNumber 校验号码不能用当前的新号
			 */
			let validatorContactNumber = (rule, value, callback) => {
				if(value) {
					if(this.phoneNo && value == this.phoneNo) {
						callback(new Error('聯絡號碼不能與上台號碼相同'))
					} else if(value.substr(0, 1).match(/[0-3]/g)) {
						callback(new Error('請輸入手機號碼'))
					} else callback()
				} else callback(new Error('請輸入聯絡號碼'))
			}
			/**
			 * @method validatorStuCardAttach 校验只有为学院计划的时候才需要上传学生证件
			 */
			let validatorStuCardAttach = (rule, value, callback) => {
				if(this.type == 2) return callback()
				if(this.$route.query.packageType == 13) {
					if(value) callback()
					else callback(new Error('請上傳學生證件'))
				} else callback()
			}
			/**
			 * @method validatorBirthday 校验必填和办理必须满18岁
			 */
			let validatorBirthday = (rule, value, callback, target) => {
				if(this.type == 2) return callback()
				// if(value) {
				// if((target === 'customerInfo_birthday' && this.form.isNonSelf == 2) || (target === 'subCustInfo_birthday' && this.form.isNonSelf == 1)) {
				// if(target === 'customerInfo_birthday' && this.form.isNonSelf == 2) {
				if(value) {
					let _min = new Date().setYear(new Date().getFullYear() - 18), // 最小辦理歲數時間戳
						_selected = new Date(this.form[target]).getTime()
					if(_selected > _min) callback(new Error('辦理該業務必須滿18周歲'))
					else callback()
				} else callback(new Error('請選擇出生日期'))
				// }else return callback()
				// }else callback(new Error('請選擇出生日期'))
			}
			/**
			 * @method validatorIsNonSelf 本人與非本人情況下的表單參數繳驗
			 */
			let validatorIsNonSelf = (rule, value, callback, target, errorText) => {
				if(this.type == 2) return callback()
				if(this.form.isNonSelf == 2) return callback()
				else {
					if(!value) callback(new Error(errorText))
					else callback()
				}
			}
			/**
			 * @method validatorCertificateCode 繳驗身份證是否正確
			 */
			let validatorCertificateCode = (rule, value, callback) => {
				console.log(value, '450')
				let rexExp1 = /[^\a-\z\A-\Z0-9]/g //不能輸入空格
				if(!value) callback(new Error('請輸入香港身份證號碼'))
				else if(rexExp1.test(value)) callback(new Error('請不要輸入空格'))
				else if(value.length < 8 || !this.$refs.customerInfo_certificateCode.second) callback(new Error('請正確輸入香港身份證號碼'))
				else callback()
			}
			return {
				showSearchTips: false, //是否显示未搜索提示语
				showShrinkUser:false,//是否显示隐藏的个人信息
				showShrinkAdress:false,//是否显示隐藏的地址栏信息
				watchClick: {}, // 是否監聽點擊位置(監聽年月日輸入情況)
				phoneNo: '',
				uploadUrl: `${config.baseUrl}${api.uploadPict}`,
				uploadUrlOcr: `${config.baseUrl}${api.uploadPicOcr}`, //ocr识别接口
				formAddressInfoVoDistrict: '', // 用于映射地区+区域的选项结果
				fromAutoTakeBoxAddressList: hongKongAreaList.cn,
				registerType: '', // 辦理方式，用於判斷是否需要生效時間
				businessPlanId: '', //服務編號id
				ruleUrl: 'https://www.hk.chinamobile.com/tc/corporate_information/Customer_Service/contract_terms_conditions/eventTnc/20191201.html',
				autoBox_cityDistrict: [],
				autoBoxIndex: '-1', //選擇的快遞櫃
				showShip: true,
				transactType: '2', //2.实体卡（网上送货)，5.esim，6.顺丰自取柜
				selectCity: '', //選擇的區域
				selectDis: '', //選擇的區域分區
				selectHot: '', //選擇的是否是熱門區域
				selectTransactType: '',
				markAutoBox: {
					show: false,
					title: '請再選一個備用櫃',
					markAutoBoxIndex: -1,
					markTakeOrg: '',
					edCode: null,
					city: '',
					district: '',
				},
				search: {
					data: [],
					value: ''
				},
				fileList: {
					otherAttach: [],
					certificateAttach: [],
					stuCardAttach: []
				},
				shipList: [], //物流列表
				sFautoTakeBoxList: [], //自取櫃列表
				sFautoTakeBoxListShow: false,
				rules: {
					...rules,
					stuCardAttach: [{
						required: true,
						validator: validatorStuCardAttach,
						trigger: 'blur'
					}],
					customerInfo_firstName: [{
						required: true,
						validator: (rule, value, callback) => validatorType(rule, value, callback, '請輸入香港身份證的英文名字'),
						trigger: 'blur'
					}],
					subCustInfo_firstName: [{
						required: true,
						validator: (rule, value, callback) => validatorIsNonSelf(rule, value, callback, 'subCustInfo_firstName', '請輸入香港身份證的英文名字'),
						trigger: 'blur'
					}],
					subCustInfo_gender: [{
						required: true,
						validator: (rule, value, callback) => validatorIsNonSelf(rule, value, callback, 'subCustInfo_gender', '請選擇性別'),
						trigger: 'blur'
					}],
					subCustInfo_lastName: [{
						required: true,
						validator: (rule, value, callback) => validatorIsNonSelf(rule, value, callback, 'subCustInfo_lastName', '請輸入香港身份證的英文姓氏'),
						trigger: 'blur'
					}],
					subCustInfo_birthday: [{
						required: true,
						validator: (rule, value, callback) => validatorIsNonSelf(rule, value, callback, 'subCustInfo_birthday', '請選擇出生日期'),
						trigger: 'blur'
					}],
					customerInfo_birthday: [{
						required: true,
						validator: (rule, value, callback) => validatorBirthday(rule, value, callback, 'customerInfo_birthday'),
						trigger: 'blur'
					}],
					addressInfoVo_streetName: [{
						required: true,
						validator: (rule, value, callback) => validatorAddressInfoVo(rule, value, callback, '請輸入街道名稱'),
						trigger: 'change'
					}],
					addressInfoVo_estateInput: [{
						required: true,
						validator: (rule, value, callback) => validatorAddressInfoVo(rule, value, callback, '請輸入屋苑名稱'),
						trigger: 'change'
					}],
					customerInfo_email: [{
						required: true,
						validator: validatorMail,
						trigger: 'blur'
					}],
					customerInfo_email2: [{
						required: true,
						validator: validatorMail2,
						trigger: 'blur'
					}],
					isNonSelf: [{
						required: true,
						validator: (rule, value, callback) => validatorType(rule, value, callback, '請選擇辦理人'),
						trigger: 'blur'
					}],
					customerInfo_gender: [{
						required: true,
						validator: (rule, value, callback) => validatorType(rule, value, callback, '請選擇性別'),
						trigger: 'blur'
					}],
					certificateAttach: [{
						required: true,
						validator: (rule, value, callback) => validatorType(rule, value, callback, '請上傳身份證件副本'),
						trigger: 'blur'
					}],
					customerInfo_contactNumber: [{
							required: true,
							validator: validatorContactNumber,
							trigger: 'blur'
						},
						{
							min: 8,
							max: 8,
							message: '輸入的聯絡號碼有誤',
							trigger: 'blur'
						}
					],
					customerInfo_certificateCode: [{
						required: true,
						validator: validatorCertificateCode,
						trigger: 'blur'
					}],
				},
				form: {
					otherAttach: '', // 其他证件
					certificateAttach: '', // 身份证證件副本
					stuCardAttach: '', // 学生证证件副本 
					isNonSelf: '2', // 是否为学生本人
					// customerInfo 扁平化的customerInfo数据
					customerInfo_lastName: '', // 姓氏
					customerInfo_firstName: '', // 名字
					customerInfo_gender: '1', // 性别
					customerInfo_birthday: '', // 出生日期
					customerInfo_certificateCode: '', // 证件号码
					customerInfo_contactNumber: '', // 聯絡電話號碼
					customerInfo_email: '', // 電郵地址
					customerInfo_email2: '', // 電郵地址
					// customerInfo_addressInfoVo 扁平化的customerInfo下addressInfoVo数据        
					addressInfoVo_area: '',
					addressInfoVo_district: '',
					addressInfoVo_streetName: '',
					addressInfoVo_estateInput: '',
					addressInfoVo_buildingInput: '',
					addressInfoVo_blockInput: '',
					addressInfoVo_floorInput: '',
					addressInfoVo_flatInput: '',
					addressInfoVo_blockBox: '',
					addressInfoVo_floorBox: '',
					addressInfoVo_flatBox: '',
					// subCustInfo 扁平化的subCustInfo数据        
					subCustInfo_birthday: '',
					subCustInfo_firstName: '',
					subCustInfo_gender: '1',
					subCustInfo_lastName: '',
					// 用戶選擇的智能自取櫃
					serviceOrgCode: '', //自取櫃編號
					takeOrg: '',
					takeRegion: '',
				},
				data: {
					district: [{
							value: '1',
							label: '香港',
							children: []
						},
						{
							value: '2',
							label: '九龍',
							children: []
						},
						{
							value: '3',
							label: '新界',
							children: []
						}
					],
					/*
					mgmCode 活动编号
					quota 配额
					recname 全名
					*/
					mgmData: {}
				},
			};
		},
		created() {
			this.getAddress()
		},
		methods: {
			typeFn(index) {
        // 用于处理是否展示優惠及vas的变化
        return index + this.disVasTotal;
			},
			handleNumInput(event) {
				let result = event.replace(/[^\d]/g,'')
				this.form.customerInfo_contactNumber = result
			},
			handleDatePickerChange(target, params) {
				this.watchClick[target] = params
			},
			/**
			 * @method watchClickTarget 獲取點擊的位置(主要用於監聽用戶是否完成選擇年月日操作)
			 */
			watchClickTarget(e) {
				for(let i in this.watchClick) {
					this.$refs.form.validateField(i)
				}
			},
			idCardFirstInputFocus() {
				this.$refs.form.clearValidate('customerInfo_certificateCode')
			},
			handleInputFocus(params) {
				let {
					first,
					second
				} = params
				if(first && !second) this.$refs.form.clearValidate('customerInfo_certificateCode')
			},
			handleInputChange(value, type) {
				if(!value) return
				this.form[type] = value.match(/[a-zA-Z\s]+/i) ? value.match(/[a-zA-Z\s]+/i).join('').toUpperCase() : ''
			},
			handleElSelectClick() {
				// 解决移动端不会弹出软键盘
				const _this = this
				setTimeout(() => {
					
				})
				_this.$refs['addressInfoVo-streetName'].focus()
				_this.$refs['el-select'].$el.querySelector('input').focus()
				this.$refs.form.clearValidate('addressInfoVo_streetName')
				this.$refs.form.clearValidate('addressInfoVo_flatInput')
			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 5;
				if (!isLt2M) {
					this.$message({
						customClass: this.$device,
						showClose: true,
						message: '上傳圖片大小不能超過 5MB!',
						type: 'warning'
					});
				}
				return isLt2M;
			},
			handleRemove(target, params) {
				this.form[target] = ''
				this.fileList[target] = []
				this.$refs.form.clearValidate(target)
			},
			handleShip(value) { //選擇物流
				console.log('value ' + value);
			},
			/**
			 * @method handleSuccess 文件上传成功相应
			 * @param {String} target 需要处理form下对应的对象属性
			 * @param {params} params 钩子返回的信息
			 * @param {String} ref 对应的上传组件的ref,用于处理上传返回非1000的情况移除上传的图片
			 */
			handleSuccessThree(target, params, ref) { //家长代办时学生证件ocr识别
				if(params.returnCode == 1000) {
					let url = params.dataInfo.url,
						_split = url.split('/')
					this.form[target] = url;
					this.fileList[target] = [{
						name: _split[_split.length - 1],
						url: url
					}];
					this.showShrinkUser=true;
					let ocr = {};
					let dataArr = [];
					if(params.dataInfo.ocr) { //如果有OCR信息
						ocr = params.dataInfo.ocr;
						ocr.englishFirstName = ocr.englishFirstName.toUpperCase();
						ocr.englishLastName = ocr.englishLastName.toUpperCase();
						if(ocr.englishFirstName.slice(0, 1) == ' ') {
							ocr.englishFirstName = ocr.englishFirstName.slice(1);
						}
						if(ocr.englishLastName.slice(0, 1) == ' ') {
							ocr.englishLastName = ocr.englishLastName.slice(1);
						}
						
						this.form.subCustInfo_lastName = ocr.englishLastName; //姓氏
						this.form.subCustInfo_firstName = ocr.englishFirstName; //名字
						this.form.subCustInfo_gender = ocr.sex == '女' ? '2' : '1'; //性别
						//							this.form.customerInfo_certificateCode=ocr.idCardNumber;//身份证
						//							this.$refs.customerInfo_certificateCode.setForm(ocr.idCardNumber)
						//
						this.form.customerInfo_certificateCode = this.$refs.customerInfo_certificateCode.getForm()
						if(ocr.birthTime) {
							dataArr = ocr.birthTime.split('-')
						}
						if (dataArr.length < 2) {
							return false;
						}
						const year = dataArr[2] || '';
						const yearSub = year.substring(0, 2)
						const validTime = (yearSub == 19 || yearSub == 20)
						if (year.length == 4 && validTime) {
							this.$nextTick(() => {
								this.$refs.subCustInfo_birthday.setForm({ //出生日期
									years: year,
									month: dataArr[1] * 1,
									date: dataArr[0] * 1
								})
							})
							this.form.subCustInfo_birthday = dataArr[2] + '-' + dataArr[1] + '-' + dataArr[0]
							console.log(this.form.subCustInfo_birthday, '1106')
						}
					}
					
					this.$nextTick(() => {
						this.$refs.form.clearValidate(target)
					})
				}else if(params.returnCode == 1002) {
					//					alert(1201)
					console.log('1131------')
					if(params.dataInfo.url) {
						let url = params.dataInfo.url,
							_split = url.split('/')
						this.form[target] = url;
						this.fileList[target] = [{
							name: _split[_split.length - 1],
							url: url
						}];
						this.showShrinkUser=true;
					}

				} else {
					this.$message({
						customClass: this.$device,
						showClose: true,
						message: params.message,
						type: 'warning'
					});
					this.form[target] = ''
					this.fileList[target] = []
				}
			},
			handleSuccessTwo(target, params, ref) { //个人上传证件成功
				if(params.returnCode == 1000) {
					let url = params.dataInfo.url,
						_split = url.split('/')
					this.form[target] = url;
					this.fileList[target] = [{
						name: _split[_split.length - 1],
						url: url
					}];
					this.showShrinkUser=true;
					let ocr = {};
					let dataArr = [];
					if(params.dataInfo.ocr) { //如果有OCR信息
						ocr = params.dataInfo.ocr;
						ocr.englishFirstName = ocr.englishFirstName.toUpperCase();
						ocr.englishLastName = ocr.englishLastName.toUpperCase();
						if(ocr.englishFirstName.slice(0, 1) == ' ') {
							ocr.englishFirstName = ocr.englishFirstName.slice(1);
						}
						if(ocr.englishLastName.slice(0, 1) == ' ') {
							ocr.englishLastName = ocr.englishLastName.slice(1);
						}
						
						this.form.customerInfo_lastName = ocr.englishLastName; //姓氏
						this.form.customerInfo_firstName = ocr.englishFirstName; //名字
						this.form.customerInfo_gender = ocr.sex == '女' ? '2' : '1'; //性别
						//							this.form.customerInfo_certificateCode=ocr.idCardNumber;//身份证
						if(ocr.idCardNumber && ocr.idCardNumber != '(') {
							this.$refs.customerInfo_certificateCode.setForm(ocr.idCardNumber)
						}
						this.form.customerInfo_certificateCode = this.$refs.customerInfo_certificateCode.getForm()
						if(ocr.birthTime) {
							dataArr = ocr.birthTime.split('-')
						}
						//FIX: TAPD ID1005800
						if (dataArr.length < 2) {
							return
						}
						const year = dataArr[2]
						const yearSub = year.substring(0, 2)
						const validTime = (yearSub == 19 || yearSub == 20)
						if (year.length == 4 && validTime) {
							this.$nextTick(() => {
								this.$refs.customerInfo_birthday.setForm({ //出生日期
									years: year,
									month: dataArr[1] * 1,
									date: dataArr[0] * 1
								})
							})
							this.form.customerInfo_birthday = dataArr[2] + '-' + dataArr[1] + '-' + dataArr[0]
						}
						console.log(this.form.customerInfo_birthday, '1102')
					}
					this.$nextTick(() => {
						this.$refs.form.clearValidate(target)
					})
				} else if(params.returnCode == 1002) {
					//					alert(1201)
					console.log('1210------')
					if(params.dataInfo.url) {
						let url = params.dataInfo.url,
							_split = url.split('/')
						this.form[target] = url;
						this.fileList[target] = [{
							name: _split[_split.length - 1],
							url: url
						}];
						this.showShrinkUser=true;
					}

				} else {
					this.$message({
						customClass: this.$device,
						showClose: true,
						message: params.message,
						type: 'warning'
					});
					console.log(ref, '-----1195');
					console.log(this.$refs[ref], '1196')
					this.form[target] = ''
					this.fileList[target] = []
				}
			},
			handleSuccess(target, params, ref) { //学生上传证件成功
				if(params.returnCode == 1000) {
					let url = params.dataInfo.url,
						_split = url.split('/')
					this.form[target] = url
					this.fileList[target] = [{
						name: _split[_split.length - 1],
						url: url
					}]
					this.$nextTick(() => {
						this.$refs.form.clearValidate(target)
					})
				} else {
					this.$message({
						customClass: this.$device,
						showClose: true,
						message: params.message,
						type: 'warning'
					});
					this.form[target] = ''
					this.fileList[target] = []
				}
			},
			async setForm(target, value) {
				// 同步组件的数据
				if(target === 'customerInfo_birthday' || target === 'subCustInfo_birthday') {
					this.$nextTick(() => {
						let _date = new Date(value * 1)
						if(this.$refs[target]) {
							const years = _date.getFullYear()
							const month = _date.getMonth() + 1
							const date = _date.getDate()
							this.$refs[target].setForm({
								years: years,
								month: month,
								date: date
							})
						}
					})
				} else if(target === 'certificateAttach' || target === 'stuCardAttach' || target === 'otherAttach') {
					if(!value) return
					let _value = value.split('/')
					this.fileList[target].push({
						url: value,
						name: _value[_value.length - 1]
					})
				} else if(target === 'customerInfo_certificateCode') {
					this.$refs.customerInfo_certificateCode.setForm(value)
					this.form[target] = this.$refs.customerInfo_certificateCode.getForm()
					return
				} else if(target === 'addressInfoVo') {
					await this.getAddress() // 防止数据还没回来～强制刷新地址
					let _temp = []
					// 检测地区是否含中文，若没有就添加该数据的选项
					if(!(/[\u4E00-\u9FA5]/.test(value.area))) {
						// 若添加新的选项临时用areaId-加数组长度记录 
						this.data.district.push({
							value: '4',
							label: value.area,
							children: [{
								value: '1',
								label: value.district
							}]
						})
					}
					this.data.district.some(e => {
						if(e.label === value.area) {
							_temp.push(e.value)
							e.children.some(ele => {
								if(ele.label === value.district) {
									return _temp.push(ele.value)
								}
							})
							return
						}
					})
					this.formAddressInfoVoDistrict = _temp
					this.form.addressInfoVo_area = value.area
					this.form.addressInfoVo_district = value.district
					this.form.addressInfoVo_streetName = value.streetName
					this.form.addressInfoVo_estateInput = value.estateInput
					this.form.addressInfoVo_buildingInput = value.buildingInput
					this.form.addressInfoVo_blockInput = value.blockInput
					this.form.addressInfoVo_floorInput = value.floorInput
					this.form.addressInfoVo_flatInput = value.flatInput
					this.form.addressInfoVo_blockBox = value.blockBox
					this.form.addressInfoVo_floorBox = value.floorBox
					this.form.addressInfoVo_flatBox = value.flatBox
					return
				}
				// 修改值
				this.form[target] = value
			},
			async setAutoBoxValue(takeRegion, edCode) {
				if(!takeRegion) {
					return
				}
				let mainEdCode = ''
				let markEdCode = ''
				if(edCode.indexOf(',') != -1) {
					let list = edCode.split(',')
					mainEdCode = list[0]
					markEdCode = list[1]
				} else {
					mainEdCode = edCode
				}

				let _value = takeRegion.split(' ')
				let area = _value[0]
				let dis = _value[1]
				await this.searchStoreSF(area, dis)
				if(this.sFautoTakeBoxList) {
					let value = -1
					let tmp = []
					let takeOrg = ''
					let edCodeT = ''
					let selectTransactType = ''
					this.fromAutoTakeBoxAddressList.forEach(element => {
						if(element.label == area) {
							let children = element.children
							tmp.push(element.value)
							children.forEach(chelement => {
								if(chelement.label == dis) {
									tmp.push(chelement.value)
								}
							})
						}
					})
					this.sFautoTakeBoxList.some((element, index) => {
						if(element.edCode === mainEdCode) {
							value = String(index)
							takeOrg = element.name
							edCodeT = element.edCode
							selectTransactType = element.transactType
						}
						return element.edCode === mainEdCode
					})
					if(value) {
						this.autoBox_cityDistrict = tmp
						this.autoBoxIndex = value
						this.form.takeOrg = takeOrg
						this.form.takeRegion = takeRegion
						this.form.serviceOrgCode = edCodeT
						console.log('this.selectTransactType ' + selectTransactType)
						this.selectTransactType = selectTransactType
						if(markEdCode) {
							console.log('markEdCode' + markEdCode)
							this.selectHot = true
							this.handlerMarkAutoBox(markEdCode) //同步後台下發的數據
						}
					} else {
						this.autoBox_cityDistrict = []
						this.autoBoxIndex = -1
						this.transactType = -1
					}
				}
			},
			handleSelectChange(params) {
				let {
					areaId,
					districtId,
					areaTcResult,
					districtTcResult,
					streetTcResult,
					bldgTcResult,
					estateTcResult,
				} = JSON.parse(params)
				// 检测地区是否含中文，若没有添加一条选项数据到选项中
				if(!(/[\u4E00-\u9FA5]/.test(areaTcResult))) {
					// 若添加新的选项临时用areaId-加数组长度记录
					let _areaId = `${areaId}-${this.data.district.length}`
					this.data.district.push({
						value: _areaId,
						label: areaTcResult,
						children: [{
							value: districtId,
							label: districtTcResult
						}]
					})
					areaId = _areaId
				}
				this.formAddressInfoVoDistrict = [areaId, districtId]
				this.handleCascaderChange([areaId, districtId])
				this.$refs.form.clearValidate('addressInfoVo_district')
				this.form.addressInfoVo_streetName = streetTcResult
				this.form.addressInfoVo_estateInput = estateTcResult
				this.form.addressInfoVo_buildingInput = bldgTcResult
				// this.form.addressInfoVo_blockInput = block
				// this.form.addressInfoVo_floorInput = floor
				// this.form.addressInfoVo_flatInput = flat
			},
			handleCascaderChange(params) {
				// 兼容新增的地址
				if(/-/.test(params[0])) {
					this.data.district.forEach(e => {
						if(e.value === params[0]) {
							this.form.addressInfoVo_area = e.label
							this.form.addressInfoVo_district = e.children[0].label
						}
					})
					return
				}
				this.form.addressInfoVo_area = ({
					'1': '香港',
					'2': '九龍',
					'3': '新界'
				})[params[0]]
				this.data.district[params[0] * 1 - 1].children.some(e => {
					if(e.value == params[1]) this.form.addressInfoVo_district = e.label
					console.log('this.form.addressInfoVo_district' + this.form.addressInfoVo_district)
					return e.value == params[1]
				})
			},
			async handleAutoBoxCascaderChange(params) {
				console.log('params' + params)
				let value = params[0]
				let chvalue = params[1]
				let area = ''
				let district = ''
				let tmp = []
				this.fromAutoTakeBoxAddressList.forEach(element => {
					if(element.value == value) {
						let children = element.children
						tmp.push(element.value)
						console.log(element.value)
						children.forEach(chelement => {
							if(chelement.value == chvalue) {
								area = element.label
								district = chelement.label
								tmp.push(chelement.value)
							}
						})
					}
				})
				if(area && district) {
					this.autoBox_cityDistrict = tmp
					//獲取智能自取櫃
					this.autoBoxIndex = -1
					this.markAutoBox.markAutoBoxIndex = -1
					this.markAutoBox.edCode = ''
					this.form.takeRegion = null
					this.selectCity = area
					this.selectDis = district
					await this.searchStoreSF(area, district)
				}
			},
			searchAddress(params) {
				if(params.length < 2) return
				this.$http('maparea/pcSearch', {
					wd: params
				}).then(res => {
					if(res.returnCode == 1000) {
            if(this.shrink){
							this.showShrinkAdress=true;//展示隐藏的区域
						}
						this.showShrinkAdress=true;//展示隐藏的区域
						this.showSearchTips = false
						this.search.data = []
						res.records.forEach(e => {
							this.search.data.push({
								label: `${e.areaTcResult}-${e.districtTcResult}-${e.streetTcResult}${e.bldgTcResult ? `-${e.bldgTcResult}` : ''}${e.estateTcResult ? `-${e.estateTcResult}` : ''}`,
								value: JSON.stringify(e)
							})
						})
					}
				})
			},
			getAddress() {
				// 先清空选项
				this.data.district.forEach(e => e.children = [])
				return this.$http('maparea/searchAreaAndDistrict').then(res => {
					if(res.returnCode == 1000) {
						res.records.forEach(e => {
							this.data.district.some(ele => {
								if(e.areaId == ele.value) {
									ele.children.push({
										label: e.districtTcResult,
										value: e.districtId
									})
								}
							})
						})
					}
				})
			},
			setRegisterType(params) {
				this.registerType = params
			},
			handleNonSelfHandle() {
				this.$nextTick(() => {
					this.$refs.form.clearValidate()
				})
			},
			toPosition(dom, offsetValue = 100) {
				let {
					offsetTop
				} = dom
				window.scroll(0, offsetTop - offsetValue)
			},
			handleAutoBoxRadio(val) {
				let boxList = this.sFautoTakeBoxList
				let boxInfo = JSON.parse(boxList[val].value)
				let isHot = boxInfo.isHot
				this.markAutoBox.edCode = ''
				this.markAutoBox.markTakeOrg = ''
				if(boxInfo) {
					this.form.serviceOrgCode = boxInfo.edCode
					this.form.takeOrg = boxInfo.twThrowaddress
					let city = boxInfo.city
					let district = boxInfo.district
					if(!city) {
						city = this.selectCity
					}
					if(!district) {
						district = this.selectDis
					}
					this.form.takeRegion = city + ' ' + district
					this.selectTransactType = boxInfo.transactType
					if(isHot == '1') {
						this.markAutoBox.show = true
						this.selectHot = true
					} else {
						this.selectHot = false
					}
				}
			},
			handlerMarkAutoBox(val) { //选择备用物流箱
				console.log('val' + val)
				this.markAutoBox.markAutoBoxIndex = val
				let boxList = this.markAutoBoxList
				let boxInfo = {}
				boxList.some(element => {
					if(element.edCode == val) {
						boxInfo = JSON.parse(element.value)
					}
					return element.edCode == val
				})
				// let boxInfo = JSON.parse(boxList[val].value)
				console.log('boxInfo.edCode' + boxInfo.edCode)
				let markTakeOrg = boxInfo.twThrowaddress
				let edCode = boxInfo.edCode
				this.markAutoBox.edCode = edCode
				this.markAutoBox.markTakeOrg = markTakeOrg
				this.markAutoBox.city = boxInfo.city
				this.markAutoBox.district = boxInfo.district
			},
			clickMarkOrg() {
				this.markAutoBox.show = true
			},
			beforeClose(done) {
				this.markAutoBox.show = false
				this.markAutoBox.edCode = ''
				this.autoBoxIndex = -1
				this.form.takeRegion = ''
				done()
			},
			handlerShipRadio(val) {
				if(val == 6) this.$emit('handleShipEffectDate');
			},
			dialogAutoBoxSure() {
				if(this.markAutoBox.edCode) {
					this.markAutoBox.show = false
				} else {
					this.$message({
						customClass: this.$device,
						showClose: true,
						message: '請選擇備用自取櫃',
						type: 'warning'
					});
				}
			},
			submitForm() {
				let _temp;
				this.$refs['form'].validate(async(valid, object) => {
					if(valid) return _temp = true
					else {
						let target = null;
						for(let i in object) {
							if(this.$refs[i]) {
								target = i
								break;
							}
						}
						if(target == 'customerInfo_certificateCode') target = 'customerInfo_certificateCode_formItem'
						if(target == 'customerInfo_birthday') target = 'customerInfo_birthday_form_item'
						if(target == 'subCustInfo_birthday') target = 'subCustInfo_birthday_form_item'
						if (target == 'addressInfoVo_district' && this.showShrinkAdress == false) {
							//输入框提示未搜索
							this.showSearchTips = true
							let positionDom = this.$refs['el-select'].$el
							this.toPosition(positionDom, 300)
						} else {
							this.toPosition(this.$refs[target].$el)
						}
						return _temp = false
					}
				});
				return _temp
			},
			getForm() {
				let _temp = {
					customerInfo: {
						addressInfoVo: {}
					},
					subCustInfo: {}
				}
				for(let i in this.form) {
					let _key = i.split('_')[1]
					if(/^customerInfo/.test(i)) _temp.customerInfo[_key] = this.form[i]
					else if(/^addressInfoVo/.test(i)) _temp.customerInfo.addressInfoVo[_key] = this.form[i]
					else if(/^subCustInfo/.test(i)) _temp.subCustInfo[_key] = this.form[i]
					else _temp[i] = this.form[i]
				}
				// 額外處理字段
				_temp.customerInfo.birthday = new Date((/-/.test(_temp.customerInfo.birthday)) ? formattingTime(_temp.customerInfo.birthday) : _temp.customerInfo.birthday * 1).getTime() // 字符串數字轉換時間戳      
				if(_temp.subCustInfo.birthday) _temp.subCustInfo.birthday = new Date(_temp.subCustInfo.birthday).getTime() // 字符串數字轉換時間戳
				_temp.customerInfo.certificateCode = `${_temp.customerInfo.certificateCode.substr(0, 7)}(${_temp.customerInfo.certificateCode.substr(7)})` // 身份證最後一位用括號抱起來
				// 若本人辦理則移除subCustInfo字段
				if(this.form.isNonSelf == '2') delete _temp['subCustInfo']
				// 给地址填充单位
				let isEN = false
				// if(!(/[\u4E00-\u9FA5]/.test(_temp.customerInfo.addressInfoVo.area))) isEN = true
				if(_temp.customerInfo.addressInfoVo.blockInput) _temp.customerInfo.addressInfoVo.blockBox = '座'
				if(_temp.customerInfo.addressInfoVo.floorInput) _temp.customerInfo.addressInfoVo.floorBox = '層'
				if(_temp.customerInfo.addressInfoVo.flatInput) _temp.customerInfo.addressInfoVo.flatBox = '單位'
				return _temp
			},
			async checkMgmValid(val) {
				let params = {
					'refereeTmCode': this.businessPlanId,
					'refereePrgcode': '1',
					'mgmCode': val,
					'msisdn': this.phoneNo
				}
				await this.$http('isMgmCodeValid', params).then(res => {
					if(res.returnCode == '1000') {
						//顯示正確推薦人
						this.mgmData.mgmCode = res.mgmCode;
						this.mgmData.quota = res.quota;
						this.mgmData.recname = res.recname;
					}
				})
			},
			async searchStoreSF(area, district) {
				//獲取順豐自取櫃列表
				if(area && district) {
					let params = {
						language: 1,
						area: area,
						district: district
					}
					const res = await this.$http("getSfLockerList", params);
					if(!res) {
						return;
					}
					if(res.returnCode != 1000) {
						return this.$message({
							customClass: this.$device,
							showClose: true,
							message: res.message,
							type: 'warning'
						});
					}
					let dataInfo = res.dataInfo;
					let autoTakeBoxList = [];
					dataInfo.forEach((element, index) => {
						let item = {
							value: JSON.stringify(element),
							name: element.twThrowaddress,
							label: index,
							holiday: element.holiday,
							saturday: element.saturday,
							workday: element.workday,
							sunday: element.sunday,
							edCode: element.edCode,
							isHot: element.isHot == '1' ? true : false,
							transactType: element.transactType
						}
						autoTakeBoxList.push(item);
					});
					debugger
					this.sFautoTakeBoxListShow = true
					this.sFautoTakeBoxList = autoTakeBoxList
				}
			},
			maskClick() {
				this.search.data = []
			}
		},
		computed: {
			stepNumber() {
				let transactType = this.transactType
				if(transactType != 5) {
					return 1
				}
				return 0
			},
			//顯示選擇智能自取櫃
			showAutoBoxSelecter() {
				let transactType = this.transactType
				if(transactType == 6 || transactType == 4) {
					return true
				}
				return false
			},
			//顯示網絡送貨提示
			showNetworkShip() {
				if(this.transactType == 2) {
					return true
				}
				return false
			},
			//备用物流箱，排除hot的物流箱列表
			markAutoBoxList() {
				let boxList = this.sFautoTakeBoxList
				let tempBox = []
				if(boxList) {
					boxList.forEach((element, index) => {
						if(!element.isHot) {
							let item = {
								value: element.value,
								name: element.name,
								label: element.edCode,
								holiday: element.holiday,
								saturday: element.saturday,
								workday: element.workday,
								sunday: element.sunday,
								edCode: element.edCode,
								isHot: element.isHot
							}
							tempBox.push(item)
							// let tempIndex = tempBox.indexOf(item)
							// item.label = tempIndex
						}
					})
					return tempBox
				}
				return tempBox
			},
		},
		components: {
			stepTitle,
			datePicker,
			idCardInput,
			checkBox,
			radioBox,
			umallSearch,
			imgTools
		}
	};
